import { css } from "@emotion/react"
import { Heading } from "@planningcenter/doxy-web"
import { Link } from "source/notifications/NotificationShow"
import PlannedGivingSummary from "./components/PlannedGivingSummary"

export default function Overview() {
  return (
    <section>
      <div className="d-f fd-c g-2">
        <div className="d-n d-f@md">
          <Heading level={1} size={2} text="Overview" />
        </div>
        <div className="d-f fd-c g-2">
          <div
            className="d-f fd-c g-2 p-2"
            css={css`
              border: 1px solid var(--color-static-gray93);
              border-radius: 8px;
            `}
          >
            <Heading level={2} size={3} text="Donation history" />
            <div
              className="action-drawer d-g jc-sb ai-c"
              css={css`
                grid-template-columns: 1fr 1fr;
              `}
            >
              <div>
                <div className="fw-600 fs-13 c-brand tt-u">
                  Given this year
                  <Heading level={3} size={1} text="$X" />
                  <div className="fs-5 fw-500 c-tint2">x in-kind donations</div>
                </div>
              </div>
              <div>
                <div className="fw-600 fs-13 c-brand tt-u">
                  Given last year
                  <Heading level={3} size={1} text="$X" />
                  <div className="fs-5 fw-500 c-tint2">x in-kind donations</div>
                </div>
              </div>
            </div>
            <Link to="/giving/profile/donations" className="fs-13 fw-500">
              View all history
            </Link>
          </div>
          <div
            className="d-f fd-c g-2 p-2"
            css={css`
              border: 1px solid var(--color-static-gray93);
              border-radius: 8px;
            `}
          >
            <div className="d-f jc-sb ai-c">
              <Heading level={2} size={3} text="Planned giving" />
              <Link
                to="/giving/profile/planned"
                className="btn outline-btn sm-btn"
              >
                Manage
              </Link>
            </div>
            <PlannedGivingSummary />
          </div>
        </div>
      </div>
    </section>
  )
}
